import { render, staticRenderFns } from "./AllocateChassisModal.vue?vue&type=template&id=d5e26aea"
import script from "./AllocateChassisModal.vue?vue&type=script&lang=js"
export * from "./AllocateChassisModal.vue?vue&type=script&lang=js"
import style0 from "./AllocateChassisModal.vue?vue&type=style&index=0&id=d5e26aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports